module.exports = __webpack_public_path__ + "img/RO_basement_IMG_5496-10.554f4bb5.jpg";